import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { CardsView, JobSearch } from "../../../Constant";
import Sidebar from "../Common";
import CardsClass from "./Cards";
import CardsPagination from "./Cards/CardsPagination";

const CardsViewContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={CardsView} parent={JobSearch} title={CardsView} />
      <Container fluid>
        <Row>
          <Col xxl="3" xl="4" className="box-col-4e">
            <div className="md-sidebar">
              <Sidebar />
            </div>
          </Col>
          <Col xxl="9" xl="8" className="box-col-8">
            <Row>
              <CardsClass />
              <CardsPagination />
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CardsViewContainer;
